module.exports = __webpack_public_path__ + "static/chemtrade-logo-aadc7f81635df7488b29003663187753.png";